// extracted by mini-css-extract-plugin
export default {"notes_link":"LastTestTableCell_notes_link__02hGM","chat_icon_wrapper":"LastTestTableCell_chat_icon_wrapper__0rc2T","count":"LastTestTableCell_count__Njvz9"};